const REMEMBER_ME_KEY = '66862af9-cc6c-45d2-ab13-1c33202445a5';
const TOKEN = '5aea9b4c-751c-4bc3-a3ac-cfc5085e26cd';
const EXPIRE_DATE = '5eb00196-355e-4785-9cea-b8a7837cda49';

export const getRememberMe = () => {
	const value = localStorage.getItem(REMEMBER_ME_KEY);
	if (value !== null) {
		return value;
	} else {
		return 2;
	}
};

export const setRememberMe = (key: string) => {
	localStorage.setItem(REMEMBER_ME_KEY, key);
};

export const getAccessToken = () => {
	setExpireTime();
	return localStorage.getItem(TOKEN);
};

export const setAccessToken = (token: string) => {
	localStorage.setItem(TOKEN, token);
};

export const getExpireTime = () => {
	return localStorage.getItem(EXPIRE_DATE);
};

export const setExpireTime = () => {
	const currentDate = new Date();
	const expDate = new Date(currentDate.getTime() + 1000 * 60 * 60 * 48);
	localStorage.setItem(EXPIRE_DATE, `${expDate.getTime()}`);
};

export const signOut = () => {
	localStorage.clear();
	window.location.reload();
};
